import styled from 'styled-components'
import { flexDirection, FlexDirectionProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

const shouldForwardProp = (prop: string) => !['flexDirection'].includes(prop)

export const Content = styled.div.withConfig({
  shouldForwardProp,
})<FlexDirectionProps>`
  display: flex;
  justify-content: center;
  color: ${themeGet('colors.text.inverse')};
  gap: ${themeGet('space.11')}px;

  ${flexDirection}
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  width: 100%;
  box-shadow: ${themeGet('shadows.block')};
  padding: ${themeGet('space.7')}px;
  border-radius: 20px;
  gap: ${themeGet('space.4')}px;

  > svg {
    width: 50px;
    height: 50px;
    color: ${themeGet('colors.primary.main')};
  }
`
